import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-reports-client-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './reports-client-page.component.html',
  styleUrl: './reports-client-page.component.css'
})
export class ReportsClientPageComponent {

}
